import type { PageContext } from 'vike/types';
import { clampMetaTitle } from '../../../utils/seo/clamp-meta-title';
import type { Data } from './+data.server';

export default function title(pageContext: PageContext): string {
  const data = (pageContext as PageContext & { data?: Data }).data;
  const metaTitle = data?.profile?.metaTitle;
  return metaTitle ? clampMetaTitle(metaTitle) : clampMetaTitle('Author | JobCrawls');
}
